import {InputImage} from "./types";

export class ImagebTool {

  public static invertBitmap(
    inputImage: InputImage
  ): InputImage {
    const pixeldata = inputImage.data;
    for (let i = 0, len = pixeldata.length; i < len; i += 4) {
      pixeldata[i] = 255 - pixeldata[i];
      pixeldata[i + 1] = 255 - pixeldata[i + 1];
      pixeldata[i + 2] = 255 - pixeldata[i + 2];
    }
    return new InputImage({
      data: pixeldata,
      width: inputImage.width,
      height: inputImage.height,
    });
  }

  public static convertGreyImg(
    inputImage: InputImage
  ): InputImage {
    const pixeldata = inputImage.data;
    for (let i = 0, len = pixeldata.length; i < len; i += 4) {
      const gray = pixeldata[i] * 0.3 + pixeldata[i + 1] * 0.59 + pixeldata[i + 2] * 0.11;
      pixeldata[i] = gray;
      pixeldata[i + 1] = gray;
      pixeldata[i + 2] = gray;
    }
    return new InputImage({
      data: pixeldata,
      width: inputImage.width,
      height: inputImage.height,
    });
  }

  public static zeroAndOne(
    inputImage: InputImage
  ): InputImage {
    const pixeldata = inputImage.data;
    const index = 255 / 2;//阈值
    for (let i = 0; i < pixeldata.length; i += 4) {
      const R = pixeldata[i]; //R(0-255)
      const G = pixeldata[i + 1]; //G(0-255)
      const B = pixeldata[i + 2]; //B(0-255)
      const Alpha = pixeldata[i + 3]; //Alpha(0-255)
      const sum = (R + G + B) / 3;
      if (sum > index) {
        pixeldata[i] = 255;
        pixeldata[i + 1] = 255;
        pixeldata[i + 2] = 255;
        pixeldata[i + 3] = Alpha;
      } else {
        pixeldata[i] = 0;
        pixeldata[i + 1] = 0;
        pixeldata[i + 2] = 0;
        pixeldata[i + 3] = Alpha;
      }
    }
    return new InputImage({
      data: pixeldata,
      width: inputImage.width,
      height: inputImage.height,
    });
  }
}

